"use client";

import { c as _c } from "react/compiler-runtime";
import { Bug } from "lucide-react";
import { cn } from "@/lib/utils";
interface DevDebugButtonProps {
  onClick: () => void;
  className?: string;
}
export default function DevDebugButton(t0) {
  const $ = _c(6);
  const {
    onClick,
    className
  } = t0;
  if (process.env.NODE_ENV !== "development") {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("fixed bottom-48 right-4 z-40 flex size-10 items-center justify-center rounded-full bg-slate-800/60 text-slate-400 transition-all hover:bg-slate-800/80 hover:text-slate-200", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Bug className="h-5 w-5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t1) {
    t3 = <button onClick={onClick} className={t1} aria-label="Debug">{t2}</button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}